import React from 'react';

import { getFormatDateFromObject, getDateFromString } from 'shared-components';
import { IRisk } from 'api-paths-cas';

import { SummaryRow } from '../../../Summary/SummaryRow';
import { isFundingRisk } from '../../../../utilities/risks';
import { Box } from '@chakra-ui/react';

interface Props {
  id: string;
  showRisks: boolean;
  risk: IRisk['financeDocsRisk']['familySponsorship'];
  selectedTextBodyReq?: string[];
  isSigned?: boolean;
  hasDate?: boolean;
  dateOnLetter?: string;
  inEnglish?: boolean;
  hasTranslation?: boolean;
  uploadedBy?: string;
}

export default function ParentLetter({
  id,
  showRisks,
  risk,
  selectedTextBodyReq,
  isSigned,
  hasDate,
  dateOnLetter,
  inEnglish,
  hasTranslation,
  uploadedBy,
}: Props) {
  const getBodyTextAnswers = () => {
    const questions = [
      {
        key: 'fullName',
        value: 'Full name matches passport',
      },
      {
        key: 'parentsName',
        value: `Parent's name`,
      },
      {
        key: 'contributionAmount',
        value: 'Amount in GBP',
      },
      {
        key: 'courseNameAndUni',
        value: 'Course name & University',
      },
      {
        key: 'contributionIntent',
        value: 'Amount for course fees / living costs',
      },
    ];

    const answers: React.ReactNode[] = [];
    questions.forEach((question, index) => {
      if (selectedTextBodyReq!.includes(question.key)) {
        answers.push(<Box key={`body-text-answer-${index}`}>{question.value}</Box>);
      } else {
        answers.push(
          <Box color={'warning'} key={`body-text-answer-not-selected-${index}`}>
            {question.value}
          </Box>,
        );
      }
    });
    return answers;
  };

  if (isSigned === undefined && hasDate === undefined && inEnglish === undefined) {
    return <div>Uploaded by {uploadedBy ? uploadedBy : 'University'}</div>;
  }
  return (
    <>
      <SummaryRow
        key="selectedTextBodyReq"
        label="Letter Contains"
        fullLabel="Does the body text of the letter include:"
        value={selectedTextBodyReq ? getBodyTextAnswers() : 'N/A'}
        isRisk={showRisks && isFundingRisk(risk, 'hasAllNames', id)}
      />

      <SummaryRow
        key="isSigned"
        label="Signed"
        fullLabel="Is it signed by the parent providing funds?"
        value={isSigned ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'isSigned', id)}
      />

      <SummaryRow
        key="hasDate"
        label="Dated"
        fullLabel="Is there a date on the letter?"
        value={hasDate ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'hasDate', id)}
      />

      {hasDate && (
        <SummaryRow
          key="dateOnLetter"
          label="Date"
          fullLabel="What is the date on the letter?"
          value={getFormatDateFromObject(getDateFromString(dateOnLetter))}
          isRisk={showRisks && isFundingRisk(risk, 'dateOnLetter', id)}
        />
      )}

      <SummaryRow
        key="inEnglish"
        label="English"
        fullLabel="Is the letter in English?"
        value={inEnglish ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
      />

      {!inEnglish && (
        <SummaryRow
          key="hasTranslation"
          label="Has Translation"
          fullLabel="Have you provided an English translation of the letter?"
          value={hasTranslation ? 'Yes' : 'No'}
          isRisk={showRisks && isFundingRisk(risk, 'inEnglishOrHasTranslation', id)}
        />
      )}
    </>
  );
}
